import { ActionReducerMap } from '@ngrx/store';
import { CoreState } from './core.state';
import { appReady } from './reducers/app-ready.reducer';

/**
 * App store.
 *
 * https://github.com/ngrx/platform/blob/master/docs/router-store/api.md#navigation-actions
 */
export const reducers: ActionReducerMap<CoreState> = {
    appReady
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/core.store.ts